// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParticipantData } from '@lfx/key-projects/key-projects.model';
import {
  OverlappingAvatarsComponent,
  AvatarItem,
} from '@lfx/shared/components/overlapping-avatars';

@Component({
  selector: 'lfx-participants-column',
  imports: [CommonModule, OverlappingAvatarsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="participants-container">
      <lfx-overlapping-avatars
        [avatars]="avatarItems()"
        [maxVisible]="5"
        [size]="'sm'"
        [expandOnHover]="false"
      />
      <span class="participant-total lf-body-base">{{ participants().count }}</span>
    </div>
  `,
  styleUrls: ['./participants-column.component.scss'],
})
export class ParticipantsColumnComponent {
  readonly participants = input.required<ParticipantData>();

  // Transform ParticipantData.avatars to AvatarItem[]
  protected readonly avatarItems = computed<AvatarItem[]>(() =>
    this.participants().avatars.map(participant => ({
      id: participant.id,
      name: participant.name,
      imageUrl: participant.avatarUrl,
    }))
  );
}

